import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpUtils } from '../../common/http/http-utils';
import { AlarmsNotifierService } from './alarm-notifier.service';
import { HttpClient } from '@angular/common/http';

let url = "/hybridity/api/techsupport/alerts";
let interval = 10000;

@Injectable()
export class AlarmsPollingService {

    private subscription: Subscription;
    private pollFailCount = 0;
    private lastQueryTime: Number = 0;

    constructor(public http: HttpClient, public alarmNotifier: AlarmsNotifierService) {
    }

    startAlarmPoller() {
        this.subscribeForAlarms();
    }

    endAlarmPoller() {
        if ( this.subscription ) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
            this.lastQueryTime = 0;
        }
    }

    pollAlarms() {
        if ( this.pollFailCount === 0 ) {
            return Observable.interval(interval).startWith(0)
                .switchMap(() => this.http.get(this.formUrl()))
                
        } else {
            return Observable.interval(interval)
                .switchMap(() => this.http.get(this.formUrl()))
                
        }
    }

    formUrl() {
        if ( this.lastQueryTime && this.lastQueryTime !== 0 ) {
            return HttpUtils.getBaseUrl() + url + '?lastQueryTime=' + this.lastQueryTime;
        } else {
            return HttpUtils.getBaseUrl() + url;
        }
    }

    subscribeForAlarms() {
        if ( !this.subscription ) {
            this.subscription = this.pollAlarms().subscribe(res => {
                    this.pollFailCount = 0;
                    this.processAlarms(res);
                },
                error => this.onPollFailure(),
                () => {
                    //todo
                }
            );
        }
    }

    onPollFailure() {
        this.pollFailCount += 1;
        this.subscription = undefined;
        if ( this.pollFailCount < 3 ) {
            this.subscribeForAlarms();
        } else {
            this.lastQueryTime = 0;
        }
    }

    processAlarms(res) {
        let alarms = [];
        let alarmsCount = 0;
        if ( res && res.data && res.data.alarms ) {
            alarms = res.data.alarms;
            alarmsCount = res.data.alarms.length;
        }
        if ( alarms && alarmsCount !== 0 ) {
            this.alarmNotifier.setAlarms(alarms);
            this.alarmNotifier.setShowAlarmsEvent();
        }
        
        if ( res ) { // todo need to remove when using general alarms api
            alarms = res.jobId ? [res] : [{}];
            this.alarmNotifier.setAlarms(alarms);
            this.alarmNotifier.setShowAlarmsEvent();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/alarm-poller.service.ts